import { useCallback } from 'react';
import { Virtuoso } from 'react-virtuoso';

import Styles from './styles.module.scss';

import type { UserModel } from '@/features/Shared/users/model/types/users.model';

interface UsersListViewProps {
	data: UserModel[];
	value?: string[];
	onChange?: (value: string[]) => void;
	isLoading?: boolean;
	fetchMore?: () => void;
}

export const UsersListView = ({
	data,
	isLoading,
	fetchMore,
	onChange,
	value,
}: UsersListViewProps) => {
	const renderItem = useCallback(
		(_index: number, item: UserModel) => {
			if (isLoading) {
				return (
					<div className={Styles.item}>
						<div className={Styles.itemSkeleton}>
							<div className={Styles.avatarSkeleton} />
							<div
								className={Styles.textSkeleton}
								style={{ width: `${Math.random() * 40 + 40}%` }}
							/>
						</div>
					</div>
				);
			}

			const isSelected = value?.includes(item.id);
			return (
				<div className={`${Styles.item} ${isSelected ? Styles.selected : ''}`}>
					<button
						type="button"
						onClick={() => {
							if (isSelected) {
								onChange?.(value?.filter((id) => id !== item.id) ?? []);
							} else {
								onChange?.([...(value ?? []), item.id]);
							}
						}}
					>
						<div className={Styles.avatar}>
							{item.firstName?.[0] ?? ''}
							{item.lastName?.[0] ?? ''}
						</div>
						<span>
							{item.firstName} {item.lastName}
						</span>
						<div className={Styles.marker}>
							<span className={Styles.plusIcon}>{isSelected ? '-' : '+'}</span>
						</div>
					</button>
				</div>
			);
		},
		[isLoading, onChange, value]
	);

	return (
		<div className={Styles.usersListContainer}>
			<Virtuoso
				data={isLoading ? new Array(10).fill({}) : data}
				style={{
					height: '100%',
					flex: 1,
				}}
				endReached={fetchMore}
				itemContent={renderItem}
			/>
		</div>
	);
};
